// extracted by mini-css-extract-plugin
module.exports =  {"swipe":"swipe--TUWM5","editable":"editable--QN4jR","inner":"inner--M8U2_","underlay":"underlay--RqLHD","swiped":"swiped--tgZ6_"};